<div class="patients-actions">
  <app-patients-actions-buttons
    [selectedOption]="selectedOption"
    (optionToggled)="onToggleOption($event.option, $event.checked)">
  </app-patients-actions-buttons>

  <!-- Select Facility: shown for Images Send and Documents (not Retrieve Images — goes directly to studies) -->
  <div *ngIf="selectedOption === 'images-sending' || selectedOption === 'documents-sending' || selectedOption === 'documents-retrieving'" class="action-panels">
    <app-patients-actions-facility
      [facilities]="facilities"
      [selectedFacility]="selectedTargetFacility"
      (facilitySelected)="onFacilitySelected($event)">
    </app-patients-actions-facility>
  </div>

  <!-- Continue button for Image Send: requires facility only -->
  <div *ngIf="selectedOption === 'images-sending' && selectedTargetFacility?.facility" class="action-footer">
    <div class="action-footer__left">
      <ng-container *ngIf="pacsUrl; else noPacs">
        <span class="action-footer__text">Select how you'd like to proceed with sending images to this facility.</span>
      </ng-container>
      <ng-template #noPacs>
        <span class="action-footer__text">Did you already send your Imaging Studies to NuageDx?</span>
      </ng-template>
    </div>
    <div class="action-footer__buttons">
      <ng-container *ngIf="pacsUrl; else continueOnly">
        <button
          mat-stroked-button
          type="button"
          (click)="continue.emit('images-sending')">
          Yes / View studies list in NuageDx
          <mat-icon>arrow_forward</mat-icon>
        </button>
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="openPacsRequested.emit(); continue.emit('images-sending')">
          No /Open PACS to send images
          <mat-icon>open_in_new</mat-icon>
        </button>
      </ng-container>
      <ng-template #continueOnly>
        <button
          mat-raised-button
          color="primary"
          type="button"
          (click)="continue.emit('images-sending')">
          Yes / View studies list in NuageDx
          <mat-icon>arrow_forward</mat-icon>
        </button>
        <button
          mat-stroked-button
          type="button"
          (click)="openTransferInfoModal()">
          No
          <mat-icon>info_outline</mat-icon>
        </button>
      </ng-template>
    </div>
  </div>

  <!-- Continue button for Documents Send: requires facility only -->
  <div *ngIf="selectedOption === 'documents-sending' && selectedTargetFacility?.facility" class="action-footer">
    <div class="action-footer__text">
      This will open the client profile for document exchange.
    </div>
    <div class="action-footer__buttons">
      <button
        mat-button
        type="button"
        (click)="resetRequested.emit()">
        Cancel
      </button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="continue.emit('documents-sending')">
        Continue
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </div>

  <!-- Continue button for Documents Retrieve: requires facility only (no users) -->
  <div *ngIf="selectedOption === 'documents-retrieving' && selectedTargetFacility?.facility" class="action-footer">
    <div class="action-footer__text">
      This will open the client profile for document exchange.
    </div>
    <div class="action-footer__buttons">
      <button
        mat-button
        type="button"
        (click)="resetRequested.emit()">
        Cancel
      </button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="continue.emit('documents-retrieving')">
        Continue
        <mat-icon>arrow_forward</mat-icon>
      </button>
    </div>
  </div>

  <!-- DEV ONLY — remove before release -->
  <div style="margin-top: 24px; text-align: center;">
    <button mat-stroked-button
            color="warn"
            type="button"
            (click)="devClientProfileRequested.emit()">
      <mat-icon>bug_report</mat-icon> [DEV] Open Client Profile
    </button>
  </div>

</div>
